import { socketHost } from '@/utils/hostsconfig'
import { initSocketMsgData } from '@/utils/auth'

let connectTimer

const relogin = () => {
  location.reload()
}

const sendSocketMsg = data => {
  let msg = initSocketMsgData(data)
  // console.log("GET_QUESTION")
  $_chat.sendKeepalive(msg)
}

const connectSocket = userInfo => {
  let socketConnInfo = {
    host: socketHost,
    port: '80'
  }
  if (window.location.protocol === 'https:') {
    socketConnInfo.port = '443'
  }
  console.log('----------------');
  const connMsg = {
    'event': 'LOGIN',
    'role': 'STUDENT',
    'stage': userInfo.stage,
    'account_id': userInfo.accountId,
    'user_id': userInfo.userId,//学生ID
    'subject_id': userInfo.subjectId,//学科ID
    'school_id': userInfo.schoolId,//学校ID 后端没有，使用默认值0
    'course_id': userInfo.courseId,//课程ID
    'course_name': userInfo.courseName,
    'lesson_id': userInfo.lessonId,//课次ID 后端没有
    'lesson_name': userInfo.lessonName,
    'topic_id': userInfo.topicId,//专题ID
    'topic_name': userInfo.topicName,
    'client_ip': userInfo.clientIp,//客户端IP
    'app_type': userInfo.appType,//可以依据学校ID来区分线上或是线下(1: 线上   2:线下）
    'nick': userInfo.realName,//昵称
    'flow_id': userInfo.flowId,//英语
  }

  window.Monitor.init(socketConnInfo.host, socketConnInfo.port, connMsg)

  window.HCISystem && new window.HCISystem.InitSuntory({ account_id: userInfo.accountId });
}

export default connectSocket



// WEBPACK FOOTER //
// ./src/connectSocket.js